import React from 'react';
import Img from "./photo.jpg";
import "./Photo.scss";

function Photo () {
  return (
    <div className="Photo">
      <img src={Img} alt="Veronika"/>
    </div>
  );
}

export default Photo;
